// extracted by mini-css-extract-plugin
export default {"root":"Body_root__Gnj8U"};